import SolelyTable from './solely-table.vue'

export default SolelyTable



// WEBPACK FOOTER //
// ./src/components/solely-table/index.js